module.exports = __webpack_public_path__ + "static/media/ar_vr_business.0afd6b08.png";